import React, { useState, useEffect } from 'react';
import {
  Grid,
  Tooltip,
  IconButton,
  // CircularProgress,
  withStyles,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useStoreState, useStoreActions } from 'easy-peasy';
import useCommonAuth from '../../submodule/hooks/useCommonAuth';
import {
  globalPageTypeEntity,
  globalAssoSearchListingTypeEntity,
} from '../../constants/applicationConstants';
import DisplayBreadcrumbs from '../../components/displayBreadcrumbs/displayBreadcrumbs';
import styles from './diagnosisCodes.module.scss';
import AddBoxIcon from '@material-ui/icons/AddBox';
// import ArchiveIcon from '@material-ui/icons/Archive';
import SyncAltIcon from '@material-ui/icons/SyncAlt';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import CustomListing from '../../components/customListing/CustomListing';
import DiagnosisCodesAddUpdate from '../../components/diagnosisCodes/dialogDiagnosisCodesAddUpdate';
import FilterSection from '../../components/filterSections/FilterSection';
import {sortByField} from '../../submodule'
import moment from 'moment';

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    marginTop: '3px',
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}))(Tooltip);

const useStyles = makeStyles({
  filterContainer: {
    padding: '30px 20px 10px 20px',
    fontSize: '20px',
    fontWeight: '600',
  },
  filterIconPopover: {
    border: '2px solid #A9A9A9',
    borderRadius: '15px 0px 15px 15px',
  },
  filterOptionsBox: {
    padding: '20px',
    background: '#EDEDED',
    minWidth: '500px',
  },
  btnCloseFiltersPopover: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: '0',
    paddingRight: '0',
  },
  paginationBox: {
    margin: '30px 0',
  },
});

const DiagnosisCodes = (props) => {
  const classes = useStyles();
  useCommonAuth();

  const diagnosisCodesAction = useStoreActions(
    (actions) => actions.diagnosisCodes,
  );

  const diagnosisCodesState = useStoreState((state) => state.diagnosisCodes);
  const commonAction = useStoreActions((actions) => actions.common);

  const [opeAddUpdateDialog, setOpeAddUpdateDialog] = useState(false);
  const [dailogHeading, setDailogHeading] = useState('');
  const [currentRowData, setCurrentRowData] = useState({});
  const [dialogType, setDialogType] = useState('');
  // const [submitMetaDataLoader, setSubmitMetaDataLoader] = React.useState(false);
  const [filteredData, setFilteredData] = useState({
    name: '',
    status: 'ALL',
    code: 'ALL',    
  });
  const searchByKeyworld = (key, value) => {
    setFilteredData({ ...filteredData, [key]: value });
  };

  function resetFilters() {
    setFilteredData({
      name: '',
      status: 'ALL',
      code: 'ALL',    
    })
  }

  const [tableData, setTableData] = React.useState(false);
  /** For filtering the data */
  useEffect(() => {
    console.log("aaaa", diagnosisCodesState.diagnosisCodesList);

    let newTableData = [...diagnosisCodesState.diagnosisCodesList];
    newTableData = newTableData.filter((data) => {
      return (
        (filteredData.name == '' ||
        data.title
          .toLocaleLowerCase()
          .match(filteredData.name.toLocaleLowerCase()) ||
        data.record_number
          .toLocaleLowerCase()
          .match(filteredData.name.toLocaleLowerCase())) && 
        (filteredData.status === 'ALL' || filteredData?.status?.toLocaleLowerCase() === data?.current_status?.toLocaleLowerCase()) && 
        (filteredData.code === 'ALL' || filteredData?.code?.toLocaleLowerCase() === data?.record_type?.toLocaleLowerCase())
        
      );
    });
    newTableData = sortByField({data: newTableData, key:'modify_date', secondKey:'create_date'});
    setTableData(newTableData);
  }, [diagnosisCodesState.diagnosisCodesList, filteredData]);

  function handleInlineStatusChange(item) {
    try {
      let reqData = {
        PK: item.PK,
        SK: item.PK,
        current_status: item.current_status,
      };
      diagnosisCodesAction
        .updateDiagnosisCodeStatus(reqData)
        .then(function (response) {
          // Now need to update the status in data
          let updatedData = tableData.map((item) => {
            if (item.PK == reqData.PK) {
              item.current_status = reqData.current_status;
              item.modify_date = moment()
            }
            return item;
          });
          diagnosisCodesAction.setDiagnosisCodesList(updatedData);
          updatedData = sortByField({data: updatedData, key: 'modify_date', secondKey: 'create_date'});
          setTableData(updatedData);
          commonAction.setSubmitSnackbar({
            status: true,
            messages: stringConstants.updateMsg,
          });
        })
        .catch(function (error) {
          if (error.response && error.response.status === 555) {
            commonAction.setSubmitSnackbar({
              status: true,
              messages: 'Error updating the status',
              error: true,
            });
          }
        });
    } catch (err) {
      console.error(err)
    }
  }

  const filterList = [    
    {
      type: 'droupdown',
      title: 'Status',
      value: filteredData.status,
      onChange: searchByKeyworld,
      searchKey: 'status',
      list: ['ALL', 'ACTIVE', 'INACTIVE'],
    },
    {
      type: 'droupdown',
      title: 'Type',
      value: filteredData.code,
      onChange: searchByKeyworld,
      searchKey: 'code',
      list: ['ALL', 'ICD-10-CM'],
    },
  ];

  const breadcrumbsNav = [
    {
      title: 'Diagnosis Codes',
      link: '/diagnosis-codes',
    },
  ];

  function getDiagnosisCodes() {
    diagnosisCodesAction.getDiagnosisCodesList();
  }

  React.useEffect(() => {
    if (
      diagnosisCodesState.diagnosisCodesList &&
      diagnosisCodesState.diagnosisCodesList.length === 0
    ) {
      getDiagnosisCodes();
    }
  }, []);

  const loadMoreHandler = () => {
    // setSubmitMetaDataLoader(true);
    diagnosisCodesAction.setDiagnosisCodesList([]);
    diagnosisCodesAction.setDiagnosisCodesLoader(true);
    getDiagnosisCodes();
  };

  //Click add form
  const addFormPopupHandler = (type, row = null) => {
    setOpeAddUpdateDialog(true);
    setDialogType(type);
    if (type === globalPageTypeEntity.add) {
      setDailogHeading('Add Diagnosis Codes');
    } else {
      setCurrentRowData(row);
      setDailogHeading(
        `${type === globalPageTypeEntity.edit ? 'Edit' : 'View'} ${row?.title}`,
      );
    }
  };

  // React.useEffect(() => {
  //   // Defaults is active records

  //   if (diagnosisCodesState.isAllDiagnosisCodesLoaded === true) {
  //     setTableData(diagnosisCodesState.diagnosisCodesList);
  //     setSubmitMetaDataLoader(false);
  //   }
  // }, [diagnosisCodesState.isAllDiagnosisCodesLoaded]);

  return (
    <Grid container direction="row">
      <DisplayBreadcrumbs items={breadcrumbsNav} />

      <Grid container direction="row" style={{ marginBottom: '50px' }}>
        <Grid container>
          <Grid item md={12} className={classes.filterContainer}>
            <Grid container>
              <Grid item md={4} style={{ display: 'flex' }} alignItems="center">
                Diagnosis Codes &nbsp;&nbsp;
              </Grid>

              <FilterSection
                filterList={filterList}
                keywordsPlaceholder="Enter Name"
                keywordskey="name"
                keywordsValue={filteredData.name}
                handleKeywordsChange={searchByKeyworld}
                resetFilters={resetFilters}
              />

              <Grid
                item
                md={4}
                alignItems="center"
                justifyContent="flex-end"
                style={{ display: 'flex' }}
              >
                <Tooltip title="Sync With Server" placement="bottom" arrow>
                  <IconButton
                    style={{ transform: 'rotate(90deg)' }}
                    aria-label="Refresh"
                    onClick={loadMoreHandler}
                    disabled={diagnosisCodesState.isBatchLoading}
                    color="primary"
                  >
                    <SyncAltIcon />
                  </IconButton>
                </Tooltip>
                {diagnosisCodesState.isBatchLoading &&
                  tableData &&
                  tableData.length > 0 && (
                    <div>
                      <LightTooltip
                        title="Loading more diagnosis codes"
                        position="bottom"
                        arrow
                        open={diagnosisCodesState.isBatchLoading}
                      >
                        <IconButton
                          className={styles.spinner}
                          aria-label="Load More"
                          onClick={loadMoreHandler}
                          color="primary"
                        >
                          <AutorenewIcon />
                        </IconButton>
                      </LightTooltip>
                    </div>
                  )}

                
                  <Tooltip title="Add New">
                    <IconButton
                      color="primary"
                      aria-label="Add"
                      onClick={() => {
                        addFormPopupHandler(globalPageTypeEntity.add);
                      }}
                    >
                      <AddBoxIcon />
                    </IconButton>
                  </Tooltip>

                {/* <Tooltip title="Archive"><IconButton><ArchiveIcon /></IconButton></Tooltip> */}
              </Grid>
            </Grid>
          </Grid>

          {/* {submitMetaDataLoader && (
            <div
              style={{
                width: '100%',
                textAlign: 'center',
                height: '100%',
                position: 'absolute',
                background: 'rgb(0 0 0 / 10%)',
                zIndex: '9999',
              }}
            >
              <CircularProgress style={{ position: 'relative', top: '50%' }} />
            </div>
          )} */}

          {/* {diagnosisCodesState.isAllDiagnosisCodesLoaded === true && ( */}
            <CustomListing
              tableData={tableData}
              isLoaded={false}
              entityType={globalAssoSearchListingTypeEntity.diagnostic_codes}
              addFormPopupHandler={addFormPopupHandler}
              handleInlineStatusChange={handleInlineStatusChange}
            />
          {/* )} */}

          <DiagnosisCodesAddUpdate
            open={opeAddUpdateDialog}
            heading={dailogHeading}
            onCloseDialog={() => {
              setOpeAddUpdateDialog(false);
            }}
            onChangeDialogType={() => {
              setDialogType(globalPageTypeEntity.edit);
              setDailogHeading(`Edit Diagnosis Codes`);
            }}
            dialogType={dialogType}
            currentRowData={currentRowData}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default DiagnosisCodes;
